<template>
  <v-app id="sapio">
    <!-- Top navigation bar -->
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase" @click="$router.push('/')">
        <v-img max-height="60" max-width="120" contain src="/img/logo.png"></v-img>
      </v-toolbar-title>
      <v-divider class="mx-4" vertical></v-divider>
      <div class="headline text-uppercase">
        <span class="mr-5" v-if="userName">Nom : <span class="font-weight-light">{{ userName }}</span></span>
        <span class="mr-5" v-if="userRole">Role : <span class="font-weight-light">{{ userRole }}</span></span>
      </div>
      <v-spacer />
      <v-btn v-if="!!userName || !!userRole" to="/login" @click="refreshUser"> LOGOUT </v-btn>
    </v-app-bar>
    <!-- Dynamic content page manager with router -->
    <v-main>
      <router-view @refreshUser="refreshUser" />
    </v-main>
    <notifications group="app" position="bottom left" />
  </v-app>
</template>

<script>
  /**
   * @brief Main view component encapsulating all the others.
   * @bug No known bugs.
   */
  export default {
    name: 'App',
    data: () => ({
      user: JSON.parse(window.localStorage.getItem('sapio_user')),
    }),
    computed: {
      userName: function () {
        return this.user ? this.user.name : undefined
      },
      userRole: function () {
        return this.user ? this.user.type : undefined
      },
    },
    methods: {
      refreshUser() {
        this.user = JSON.parse(window.localStorage.getItem('sapio_user'))
      },
    },
  }
</script>

<style>
  #sapio {
    background: #858585;
  }

  body {
    background-color: #858585;
  }

  .theme--light.v-application {
    background: #858585;
  }

  .background h2 {
    font-weight: bold;
    line-height: 1.3;
    font-family: 'Roboto', sans-serif;
  }

  .background h3 {
    font-size: 6vh;
    font-family: 'Roboto', sans-serif;
  }

  .background p {
    font-family: 'Roboto', sans-serif;
  }

  .background {
    background-size: cover;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .listDYK {
    width: 60%;
    padding: 0.5vw;
  }

  .pageSeparatorGoogle {
    position: absolute;
    width: 0.6%;
    height: 80%;
    top: 10%;
    left: 59%;
    background-color: #858585;
    border-radius: 30px 30px 30px 30px;
    max-width: 10px;
  }

  .ql-align-center {
    text-align: center;
  }

  .next {
    bottom: 5%;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 2vh;
    height: 6vh;
    border-radius: 10px;
    padding: 0 1vh;
  }

  .debugNext {
    right: 160px;
    top: 60px;
    position: absolute;
  }

  @media (min-aspect-ratio: 16/9) {
    .background h1 {
      font-size: 9vh;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h2 {
      font-size: 8vh;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h3 {
      font-size: 7.1vh;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h4 {
      font-size: 6vh;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }

    .background p {
      font-size: 5vh;
      line-height: 5vh;
      font-family: 'Roboto', sans-serif;
    }
    .background em {
      font-size: 4.5vh;
      line-height: 4.5vh;
      font-family: 'Roboto', sans-serif;
    }
    .v-btn-toggle > .v-btn.v-btn {
      font-size: 4.44vh;
    }
    .listDYK {
      font-size: 4.4vh;
      padding: 0 1vh 0 0;
    }
    .listDYK li {
      margin-top: 1vh;
    }
    .listDYK p {
      font-size: 4.4vh;
      text-align: left;
      font-weight: normal;
    }
    .listDYK h3 {
      font-size: 4.4vh;
      text-align: left;
      font-weight: normal;
    }
    .OKGoogle {
      width: 40%;
      padding: 0.5vw;
      font-size: 4.4vh;
      padding: 0 1vh 0 1vh;
      font-weight: bold;
    }
  }

  @media (max-aspect-ratio: 16/9) {
    .background h1 {
      font-size: 5.06vw;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h2 {
      font-size: 4.5vw;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h3 {
      font-size: 4vw;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background h4 {
      font-size: 3.375vw;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
    }
    .background p {
      font-size: 2.8vw;
      line-height: 2.8vw;
      font-family: 'Roboto', sans-serif;
    }

    .background em {
      font-size: 2.53vw;
      line-height: 2.53vw;
      font-family: 'Roboto', sans-serif;
    }

    .v-btn-toggle > .v-btn.v-btn {
      font-size: 2.5vw;
    }
    .listDYK {
      font-size: 2.5vw;
      padding: 0 0.5vw 0 0;
    }
    .listDYK li {
      margin-top: 0.6vw;
    }
    .listDYK p {
      font-size: 2.5vw;
      text-align: left;
      font-weight: normal;
    }
    .listDYK h3 {
      font-size: 2.5vw;
      text-align: left;
      font-weight: normal;
    }
    .OKGoogle {
      width: 40%;
      padding: 0.5vw;
      font-size: 2.5vw;
      padding: 0 0.5vw 0 0.5vw;
      font-weight: bold;
    }
  }

  .listDYK ul {
    padding-left: 10px;
  }
  
  .icon {
    font-size: 7vh;
  }

  #notification {
    position: fixed;
    bottom: 0.5em;
    width: 20vw;
    font-size: 1em;
    transition-duration: 1s;
    background-color: white;
    padding: 0.5em;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .showNotification {
    right: 0;
  }
  .hideNotification {
    right: -20vw;
  }

  .hof {
    top: 2vh;
  }

  .timer {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 6vh;
    font-weight: bold;
    bottom: 10%;
    color: #444343;
    z-index: 100;
  }
  .pageContainer {
    top: 10.7%;
    width: 100%;
    height: 73%;
    position: absolute;
  }
  .centerText {
    position: absolute;
    width: 100%;
    padding: 50px;
    font-size: 2em;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .semiWhite {
    background-color: rgba(255, 255, 255, 0.8);
  }

  .actionBar {
    position: absolute;
    width: 100%;
    height: 16.6%;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .answer {
    margin: 5px;
  }

  .leftText {
    position: absolute;
    width: 100%;
    font-size: 5vh;
    top: 13%;
    text-align: center;
    font-weight: bold;
  }

  #bottomprogress {
    transition-timing-function: linear;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 0vw;
    height: 5px;
    background-color: blue;
  }

  .w-100 {
    width: 100%;
  }

  .centerFull {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
</style>